import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';

const TERMS_URL = 'https://corp.feast.co.jp/legal/terms/';
const PRIVACY_URL = 'https://corp.feast.co.jp/legal/privacy/';
const CORP_URL = 'https://corp.feast.co.jp';

/**
 * 認証まわりの公開ページ（新規登録・ログアウト等）用のシンプルなフッター。
 * 法務文書と運営会社への導線を置く。feast-fe ADR 0032。
 */
const SiteFooter: React.FC = () => (
  <Box component="footer" sx={{ mt: 'auto', py: 3, borderTop: '1px solid', borderColor: 'divider' }}>
    <Container maxWidth="sm">
      <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" sx={{ mb: 1 }}>
        <Link href={TERMS_URL} target="_blank" rel="noopener" variant="caption" color="text.secondary" underline="hover">
          利用規約
        </Link>
        <Link href={PRIVACY_URL} target="_blank" rel="noopener" variant="caption" color="text.secondary" underline="hover">
          プライバシーポリシー
        </Link>
        <Link href={CORP_URL} target="_blank" rel="noopener" variant="caption" color="text.secondary" underline="hover">
          運営会社
        </Link>
      </Stack>
      <Typography variant="caption" color="text.secondary" display="block" textAlign="center">
        © FEAST株式会社
      </Typography>
    </Container>
  </Box>
);

export default SiteFooter;
